<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<form *ngIf="formGroup" [formGroup]="formGroup">
    <mat-card appearance="raised">
        <mat-card-header>
            <mat-card-title>{{'fde-settings.title' | translate}}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <!-- Failed logins before lockout -->
            <div class="row slider">
                <div>
                  {{'pba-settings.failed-logins-before-lockout' | translate}}
                  <span tabindex="0"
                      attr.aria-label="{{'pba-settings.failed-logins-before-lockout-tooltip' | translate}}"
                      matTooltip="{{'pba-settings.failed-logins-before-lockout-tooltip' | translate}}"
                      matTooltipPosition="right">
                      <span class="mdi mdi-information-outline"></span>
                  </span>
                </div>
                <label class="min-lock-label label">{{failedLoginsLockoutMin}}</label>
                <mat-slider
                    id="password-lock-interval"
                    class="timeout-slider"
                    [max]="failedLoginsLockoutMax"
                    [min]="failedLoginsLockoutMin"
                    [step]="1">
                      <input matSliderThumb
                             formControlName="failedLoginsBeforeLockout"
                             (input)="onDataChanged()"
                             #ngSliderThumbLock="matSliderThumb" />
                </mat-slider>
                <label class="max-lock-label-two-digit label">{{failedLoginsLockoutMax}}</label>
                <span class="input-wrapper">
                  <app-numeric-input
                      id="password-lock-interval-input"
                      [inputStyles]="inputStyles"
                      [inputLabelStyles]="inputAttemptsLabelStyles"
                      [min]="failedLoginsLockoutMin"
                      [max]="failedLoginsLockoutMax"
                      step="1"
                      [value]="ngSliderThumbLock?.value"
                      [showProgressBar]="false"
                      labelPosition="right"
                      inputPosition="right"
                      label=""
                      [showMinMax]="false"
                      [disabled]="false"
                      (valueChanged)="onPasswordLockInputChanged($event)">
                  </app-numeric-input>
                </span>
            </div>

            <!-- Failed logins before erase -->
            <div class="row slider">
                <div>
                  {{'pba-settings.failed-logins-before-erase' | translate}}
                  <span tabindex="0"
                      attr.aria-label="{{'pba-settings.failed-logins-before-erase-tooltip' | translate}}"
                      matTooltip="{{'pba-settings.failed-logins-before-erase-tooltip' | translate}}"
                      matTooltipPosition="right">
                      <span class="mdi mdi-information-outline"></span>
                  </span>
                </div>
                <label class="min-lock-label label">{{failedLoginsEraseMin}}</label>
                <mat-slider
                    id="password-erase-interval"
                    class="timeout-slider"
                    [max]="failedLoginsEraseMax"
                    [min]="failedLoginsEraseMin"
                    [step]="1">
                      <input matSliderThumb
                             formControlName="failedLoginsBeforeErase"
                             (input)="onDataChanged()"
                             #ngSliderThumbErase="matSliderThumb" />
                </mat-slider>
                <label class="max-lock-label-three-digit label">{{failedLoginsEraseMax}}</label>
                <span class="input-wrapper">
                  <app-numeric-input
                      id="password-erase-interval-input"
                      [inputStyles]="inputStyles"
                      [inputLabelStyles]="inputAttemptsLabelStyles"
                      [min]="failedLoginsEraseMin"
                      [max]="failedLoginsEraseMax"
                      step="1"
                      [value]="ngSliderThumbErase?.value"
                      [showProgressBar]="false"
                      labelPosition="right"
                      inputPosition="right"
                      label="{{ngSliderThumbErase?.value === 0 ? ('DISABLED' | translate) : ('pba-settings.slider-input-label' | translate)}}"
                      [showMinMax]="false"
                      [disabled]="false"
                      (valueChanged)="onPasswordEraseInputChanged($event)">
                  </app-numeric-input>
                </span>
            </div>

            <!-- Password history -->
            <div class="row slider">
                <div>
                  {{'pba-settings.password-history' | translate}}
                  <span tabindex="0"
                      attr.aria-label="{{'pba-settings.password-history-tooltip' | translate}}"
                      matTooltip="{{'pba-settings.password-history-tooltip' | translate}}"
                      matTooltipPosition="right">
                      <span class="mdi mdi-information-outline"></span>
                  </span>
                </div>
                <label class="min-lock-label label">{{passwordHistoryMin}}</label>
                <mat-slider
                    id="password-history-interval"
                    class="timeout-slider"
                    [max]="passwordHistoryMax"
                    [min]="passwordHistoryMin"
                    [step]="1">
                      <input matSliderThumb
                             formControlName="passwordHistory"
                             (input)="onDataChanged()"
                             #ngSliderThumbHistory="matSliderThumb" />
                </mat-slider>
                <label class="max-lock-label-two-digit label">{{passwordHistoryMax}}</label>
                <span class="input-wrapper">
                  <app-numeric-input
                      id="password-history-interval-input"
                      [inputStyles]="inputStyles"
                      [inputLabelStyles]="inputAttemptsLabelStyles"
                      [min]="passwordHistoryMin"
                      [max]="passwordHistoryMax"
                      step="1"
                      [value]="ngSliderThumbHistory?.value"
                      [showProgressBar]="false"
                      labelPosition="right"
                      inputPosition="right"
                      label=""
                      [showMinMax]="false"
                      [disabled]="false"
                      (valueChanged)="onPasswordHistoryChanged($event)">
                  </app-numeric-input>
                </span>
            </div>

            <!-- Password minimum -->
            <div class="row slider">
                <div>
                  {{'pba-settings.password-min-length' | translate}}
                  <span tabindex="0"
                      attr.aria-label="{{'pba-settings.password-min-length-tooltip' | translate}}"
                      matTooltip="{{'pba-settings.password-min-length-tooltip' | translate}}"
                      matTooltipPosition="right">
                      <span class="mdi mdi-information-outline"></span>
                  </span>
                </div>
                <label class="min-lock-label label">{{passwordMinimumMin}}</label>
                <mat-slider
                    id="password-minimum-interval"
                    class="timeout-slider"
                    [max]="passwordMinimumMax"
                    [min]="passwordMinimumMin"
                    [step]="1">
                      <input matSliderThumb
                             formControlName="passwordMinimum"
                             (input)="onDataChanged()"
                             #ngSliderThumbMinimum="matSliderThumb" />
                </mat-slider>
                <label class="max-lock-label-three-digit label">{{passwordMinimumMax}}</label>
                <span class="input-wrapper">
                  <app-numeric-input
                      id="password-minimum-interval-input"
                      [inputStyles]="inputStyles"
                      [inputLabelStyles]="inputAttemptsLabelStyles"
                      [min]="passwordMinimumMin"
                      [max]="passwordMinimumMax"
                      step="1"
                      [value]="ngSliderThumbMinimum?.value"
                      [showProgressBar]="false"
                      labelPosition="right"
                      inputPosition="right"
                      label=""
                      [showMinMax]="false"
                      [disabled]="false"
                      (valueChanged)="onPasswordMinimumChanged($event)">
                  </app-numeric-input>
                </span>
            </div>
            <div class="row">
              <mat-checkbox formControlName="enableRememberMe" (change)="onDataChanged()" labelPosition="before">
                {{'pba-settings.enable-remember-me' | translate}}
                <span tabindex="0"
                    attr.aria-label="{{'pba-settings.enable-remember-me-tooltip' | translate}}"
                    matTooltip="{{'pba-settings.enable-remember-me-tooltip' | translate}}"
                    matTooltipPosition="right">
                    <span class="mdi mdi-information-outline"></span>
                </span>
              </mat-checkbox>
            </div>
        </mat-card-content>
    </mat-card>
</form>

